import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Dashboard from "../pages/dashboard/page";
import DashboardLoginPage from "../pages/dashboard-login/page";
import DashboardAuthGuard from "../components/DashboardAuthGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },

  // 🔐 LOGIN
  {
    path: "/dashboard-login",
    element: <DashboardLoginPage />,
  },

  // 🔒 DASHBOARD PROTEGIDO
  {
    path: "/dashboard",
    element: (
      <DashboardAuthGuard>
        <Dashboard />
      </DashboardAuthGuard>
    ),
  },

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;